module.exports = __webpack_public_path__ + "img/undraw_posting_photo_v65l.a47f7568.svg";